import React from 'react';
import ReactPlayer from 'react-player';

import { VideoBackground, VideoForeground } from './styles';

const BackgroundVideo = ({ video, playing = true, muted = false }) => (
  <>
    <VideoBackground>
      <VideoForeground>
        <ReactPlayer
          url={video}
          playing={playing}
          controls={false}
          loop
          muted={muted}
        />
      </VideoForeground>
    </VideoBackground>
  </>
);

export default BackgroundVideo;
